// The 46 area pages, grouped by where they actually are.
//
// THIS FILE IS A MIRROR, like ./../hero/frames.js. The source of truth is
// seo/areas.yml and app/services/seo/area.rb: `slug`, `name` and `outcodes`
// are copied from the file verbatim, in file order, and `areaPath` is the one
// line of Seo::Area#path. Nothing here was typed by hand - the rows below
// were generated by reading the YAML, which is the only way to put 46 names
// and 62 outward codes in a bundle without a typo. Regenerate the same way
// when an area is added, removed or renamed (and, on a removal, add the
// place to RETIRED_AREAS below):
//
//   ruby -ryaml -rdate -e 'YAML.load_file("seo/areas.yml",
//     permitted_classes: [Date]).each { |slug, row|
//     puts "  { slug: %p, name: %p, outcodes: [%s] }," % [slug, row["name"],
//       Array(row["outcodes"]).map { |c| c.upcase.inspect }.join(", ")] }'
//
// A slug that already ranks MUST NOT change (seo/areas.yml, SEO_STRATEGY.md
// §3), so a rename here is a rename of a URL and not a cosmetic edit.
//
// WHY THE GROUPING IS A RULE AND NOT A TABLE. Fable's audit asked for these
// links grouped by geography rather than alphabetically, and the obvious way
// to do that is to write nine lists of names. That is 52 chances to misfile
// Cheshunt and nobody would ever notice. So the group is DERIVED from the
// first outward code of each area, which is the same field the area page
// reads its wash counts from: get it wrong and the page itself is already
// wrong. Add an area to the YAML, copy its row in, and it files itself.

export const AREAS = [
  { slug: 'fulham', name: 'Fulham', outcodes: ['SW6'] },
  { slug: 'chelsea', name: 'Chelsea', outcodes: ['SW3', 'SW10'] },
  { slug: 'south-kensington', name: 'South Kensington', outcodes: ['SW7', 'SW5'] },
  { slug: 'kensington', name: 'Kensington', outcodes: ['W8', 'W14'] },
  { slug: 'notting-hill', name: 'Notting Hill', outcodes: ['W11', 'W10'] },
  { slug: 'paddington', name: 'Paddington', outcodes: ['W2'] },
  { slug: 'maida-vale', name: 'Maida Vale', outcodes: ['W9'] },
  { slug: 'hammersmith', name: 'Hammersmith', outcodes: ['W6'] },
  { slug: 'shepherds-bush', name: "Shepherd's Bush", outcodes: ['W12'] },
  { slug: 'chiswick', name: 'Chiswick', outcodes: ['W4'] },
  { slug: 'battersea', name: 'Battersea', outcodes: ['SW11'] },
  { slug: 'clapham', name: 'Clapham', outcodes: ['SW4'] },
  { slug: 'balham', name: 'Balham', outcodes: ['SW12'] },
  { slug: 'wandsworth', name: 'Wandsworth', outcodes: ['SW18'] },
  { slug: 'putney', name: 'Putney', outcodes: ['SW15'] },
  { slug: 'wimbledon', name: 'Wimbledon', outcodes: ['SW19'] },
  { slug: 'tooting', name: 'Tooting', outcodes: ['SW17'] },
  { slug: 'streatham', name: 'Streatham', outcodes: ['SW16'] },
  { slug: 'brixton', name: 'Brixton', outcodes: ['SW2'] },
  { slug: 'barnes', name: 'Barnes', outcodes: ['SW13'] },
  { slug: 'pimlico', name: 'Pimlico & Victoria', outcodes: ['SW1V', 'SW1W'] },
  { slug: 'knightsbridge', name: 'Knightsbridge & Belgravia', outcodes: ['SW1X'] },
  { slug: 'westminster', name: 'Westminster', outcodes: ['SW1A', 'SW1H', 'SW1P'] },
  { slug: 'camden', name: 'Camden', outcodes: ['NW1'] },
  { slug: 'st-johns-wood', name: "St John's Wood", outcodes: ['NW8'] },
  { slug: 'hampstead', name: 'Hampstead', outcodes: ['NW3', 'NW11'] },
  { slug: 'kilburn', name: 'Kilburn & West Hampstead', outcodes: ['NW6'] },
  { slug: 'willesden', name: "Willesden & Queen's Park", outcodes: ['NW10'] },
  { slug: 'islington', name: 'Islington', outcodes: ['N1', 'N5'] },
  { slug: 'hackney', name: 'Hackney', outcodes: ['E8', 'E5', 'E9'] },
  { slug: 'stoke-newington', name: 'Stoke Newington', outcodes: ['N16'] },
  { slug: 'crouch-end', name: 'Crouch End & Hornsey', outcodes: ['N8'] },
  { slug: 'greenwich', name: 'Greenwich', outcodes: ['SE10', 'SE3'] },
  { slug: 'blackheath-lewisham', name: 'Lewisham & Blackheath', outcodes: ['SE13', 'SE4'] },
  { slug: 'nunhead', name: 'Nunhead & Peckham', outcodes: ['SE15'] },
  { slug: 'ealing', name: 'Ealing', outcodes: ['W5', 'W13'] },
  { slug: 'greenford', name: 'Greenford', outcodes: ['UB6'] },
  { slug: 'ruislip', name: 'Ruislip', outcodes: ['HA4'] },
  { slug: 'brentford', name: 'Brentford', outcodes: ['TW8'] },
  { slug: 'enfield', name: 'Enfield', outcodes: ['EN1', 'EN2'] },
  { slug: 'enfield-highway', name: 'Enfield Highway', outcodes: ['EN3'] },
  { slug: 'cheshunt', name: 'Cheshunt', outcodes: ['EN7', 'EN8'] },
  { slug: 'potters-bar', name: 'Potters Bar', outcodes: ['EN6'] },
  { slug: 'romford', name: 'Romford', outcodes: ['RM1', 'RM2', 'RM3', 'RM5', 'RM7'] },
  { slug: 'dagenham', name: 'Dagenham', outcodes: ['RM8', 'RM9', 'RM10'] },
  { slug: 'chadwell-heath', name: 'Chadwell Heath', outcodes: ['RM6'] }
]

// Places that had a page and no longer do: retired on 2026-10-15
// (docs/SEO_AUDIT_2026-10-14.md section C), each URL now a 301 kept in
// SeoRedirects::RETIRED. They are never linked. They are here only so a
// photo from one of these postcodes is still captioned with the place it was
// taken in ("Canary Wharf E14"), which stays true when the page has gone,
// rather than with the page it redirects to, which would not be.
export const RETIRED_AREAS = [
  { slug: 'marylebone', name: 'Marylebone', outcodes: ['W1U', 'W1H', 'W1G'] },
  { slug: 'isle-of-dogs', name: 'Isle of Dogs & Canary Wharf', outcodes: ['E14'] },
  { slug: 'london-colney', name: 'London Colney', outcodes: ['AL2'] },
  { slug: 'biggin-hill', name: 'Biggin Hill', outcodes: ['TN16'] },
  { slug: 'chertsey', name: 'Chertsey', outcodes: ['KT16'] },
  { slug: 'leatherhead', name: 'Leatherhead', outcodes: ['KT22'] }
]

// Seo::Area#path. The area pages are the oldest URLs on the site and this
// shape is what Search Console knows, so it is stated once, here.
export const areaPath = area => `/mobile-car-wash-valet-in-${area.slug}`

// The nine groups, in the order the audit asked for them: the London
// compass points first, then the outer towns by county.
//
// `Essex` holds Romford, Dagenham and Chadwell Heath. All three are Greater
// London boroughs today, and all three are the RM postal area, which is
// still addressed as Essex and was Essex until 1965. It is the heading a
// customer there would look under, which is the only test that matters for
// a list whose job is to be scanned.
const GROUPS = [
  { id: 'south-west', name: 'South West London' },
  { id: 'west', name: 'West London' },
  { id: 'north', name: 'North London' },
  { id: 'east', name: 'East London' },
  { id: 'south-east', name: 'South East London' },
  { id: 'hertfordshire', name: 'Hertfordshire' },
  { id: 'essex', name: 'Essex' },
  { id: 'surrey', name: 'Surrey' },
  { id: 'kent', name: 'Kent' }
]

// Which group an outward code belongs to, by its postal area letters.
//
//   SW                 south west London
//   W, UB, HA, TW      west London: Ealing, Greenford, Ruislip, Brentford
//                      are all west London boroughs, whatever their letters
//   N, NW              north London
//   E                  east London
//   SE                 south east London
//   AL                 Hertfordshire
//   RM                 Essex (see the note on GROUPS)
//   KT                 Surrey
//   TN                 Kent
//
// EN is the one area that is split, because the postal area is. EN1 to EN5
// are the London Borough of Enfield; EN6 and up are Hertfordshire, which is
// where Potters Bar and Cheshunt really are. Filing Enfield under
// Hertfordshire would be a plain factual error on a page that exists to say
// where we work.
const LETTERS = {
  SW: 'south-west',
  W: 'west',
  UB: 'west',
  HA: 'west',
  TW: 'west',
  N: 'north',
  NW: 'north',
  E: 'east',
  SE: 'south-east',
  AL: 'hertfordshire',
  RM: 'essex',
  KT: 'surrey',
  TN: 'kent'
}

const groupIdOf = outcode => {
  const [, letters, district] = /^([A-Z]{1,2})(\d+)/.exec(outcode) || []
  if (!letters) return null
  if (letters === 'EN') return Number(district) <= 5 ? 'north' : 'hertfordshire'
  return LETTERS[letters] || null
}

// The groups with their areas, alphabetical inside each one. A group with
// nothing in it is dropped rather than printed empty, and an area whose
// letters are not in the table above is dropped rather than guessed at: a
// link in the wrong place is worse than a link missing from a list that is
// regenerated whenever the YAML changes.
export const AREA_GROUPS = GROUPS.map(group => ({
  ...group,
  areas: AREAS.filter(area => groupIdOf(area.outcodes[0]) === group.id).sort((a, b) =>
    a.name.localeCompare(b.name, 'en-GB')
  )
})).filter(group => group.areas.length > 0)

// What the paragraph above the list says, counted rather than typed, so it
// cannot claim 52 areas on the day a fifty third is added.
export const AREA_COUNT = AREA_GROUPS.reduce((n, group) => n + group.areas.length, 0)
